module.exports = __webpack_public_path__ + "c605ad320ee52f155474d3d61b608fb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/cardPay_active.png
// module id = 575
// module chunks = 0